import auth from './modules/auth'
import register from './modules/register'
import plans from './modules/plans'
import client from './modules/client'
import roles from './modules/roles'
import users from './modules/users'
import courses from './modules/courses'
import progress from './modules/progress'
import reports from './modules/reports'
import certificate from './modules/certificate'

export default {
  auth,
  register,
  plans,
  client,
  roles,
  users,
  courses,
  progress,
  reports,
  certificate,
}
